import { c as _c } from "react/compiler-runtime";
import { EmptyStateIcon } from '@systemeio/icons';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
const NotificationEmptyList = () => {
  const $ = _c(12);
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <EmptyStateIcon className="size-30" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("dashboard.notifications.empty_list.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <span className="text-lg font-medium">{t1}</span>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("dashboard.notifications.empty_list.description");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <span className="text-text-tertiary text-base">{t3}</span>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="my-auto flex w-full flex-col items-center justify-center gap-2.5 px-4 py-8 text-center">{t0}<div className="flex flex-col items-center gap-1">{t2}{t4}</div></div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default NotificationEmptyList;